// AppLoginDict.js
import IsValid from "../../value/IsValid";
import { AppWord, InputType } from "../../value/AppConst";

export const AppLoginDict = {
    inputMap: {
        userId: {
            id: 'userId', required: true, toAdd: true,
            label: '사용자 ID', size: AppWord.MEDIUM,
            type: InputType.text,
            min: 3, max: 30,
            check: (value)=>{return IsValid.userId(value)}
        },
        password: {
            id: 'password', required: true, toAdd: true,  // toEdit: true,
            label: '사용자 암호', size: AppWord.MEDIUM,
            // placeholder: '중요 작업 시 본인 확인용',
            type: InputType.password,
            min: 1, max: 20,
            check: (value)=>{return IsValid.passwordOldSite(value)}
        },
    },
};